import { createContext, useContext } from 'react';
import type { DashboardTheme } from './types';

const DashboardThemeContext = createContext<DashboardTheme | undefined>(undefined);

export const DashboardThemeProvider = DashboardThemeContext.Provider;

export function useDashboardTheme(): DashboardTheme | undefined {
  return useContext(DashboardThemeContext);
}
